<template :style="myStyle">
  <div style="background: #fff" class="custom-container">
    <CContainer :style="myStyle">
      <br />
      <!-- <CButton color="light" href="/"
        ><CIcon name="cil-home" /> &nbsp; Back to Home</CButton
      > -->

      <CHeaderNavLink to="/">
            <CButton color="light" size="sm"
              >Back to Home</CButton
            ></CHeaderNavLink
          >


      <h1 class="text-center mb-5">Packages</h1>
      <CRow>
        <CCol sm="3" lg="3">
          <CCard color="light" class="mt-3">
            <h3 class="text-center mt-5">1 to 1 (1 hr) </h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">30</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">30</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center">
              Only one student for intensive
              learning
            </label>
            <hr />
            <label class="text-center"><strong> - For primary student only</strong></label>
            <label class="text-center"> - Pay per Session/Monthly</label>
            <label class="text-center"
              > - Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-3"
                  href="https://wa.me/600106597700?text=+Request info for package 1 to 1 (1hr), primary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>

         <CCol sm="3" lg="3">
          <CCard style="background-color: rgba(255, 118, 72, 1)">
              <label
              style="
                background-color: rgba(255, 187, 163, 1);
                width: 100px;
                margin: -10px auto;
              "
              class="text-center"
              >Best Value</label
            >
            <h3 class="text-center mt-5">1 to 1 (40 min) </h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label mt-4"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label mt-3">20</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">20</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center">
              Only one student for intensive 
              learning
            </label>
            <hr />
            <label class="text-center"><strong>- For primary student only</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >- Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-5"
                  href="https://wa.me/600106597700?text=+Request info for package 1 to 1 (40 min), primary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
       
        <CCol sm="3" lg="3" class="mt-3">
          <CCard color="light">
            <h3 class="text-center mt-5">1 to 1 (1 hr)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">35</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">35</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center">
              Only one student in the class for intensive learning
            </label>
            <hr />
            <label class="text-center"><strong>- For secondary student only</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >- Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  href="https://wa.me/600106597700?text=+Request info for package 1 to 1 (1hr), secondary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
         <CCol sm="3" lg="3" class="mt-3">
          <CCard style="background-color: rgb(255 200 180)">
            <h3 class="text-center mt-5">1 to 1 (40 min)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">24</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">24</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center">
              Only one student in the class for intensive learning
            </label>
            <hr />
            <label class="text-center"><strong>- For secondary student only</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >- Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  href="https://wa.me/600106597700?text=+Request info for package 1 to 1 (40 min), secondary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
         <CCol sm="3" lg="3">
          <CCard color="light" class="mt-3">
            <h3 class="text-center mt-5">Group of 2 (1 hr)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">15</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">15</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center"> 2 students in the class </label>

            <br />
            <hr />
            <label class="text-center"><strong>- For primary student only</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >- Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-3"
                  href="https://wa.me/600106597700?text=+Request info for package Group of 2 (1hr), primary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
        <CCol sm="3" lg="3" class="mt-3">
          <CCard color="light">
            <h3 class="text-center mt-5">Group of 2 (1 hr)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">18</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">18</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center"> 2 students in class </label>
            <br />
            <hr />
            <label class="text-center"><strong>- For secondary student only</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-3"
                  href="https://wa.me/600106597700?text=+Request info for package Group (1hr), secondary school"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
         <CCol sm="3" lg="3" class="mt-3">
          <CCard color="light">
            <h3 class="text-center mt-5">Group of 2 (1 hr)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">22</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">22</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center"> 2 students in class </label>
            <br />
            <hr />
            <label class="text-center"><strong>- for 18 years and above</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-3"
                  href="https://wa.me/600106597700?text=+Request info for package Group (1hr), 18 years and above"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
          <CCol sm="3" lg="3" class="mt-3">
          <CCard color="light">
            <h3 class="text-center mt-5">Adult 1 to 1 (1 hr)</h3>
            <CRow class="d-none d-sm-flex">
              <CCol sm="4" lg="4">
                <label class="float-right price-label"
                  ><strong>RM</strong></label
                >
              </CCol>
              <CCol sm="8" lg="8">
                <label class="float-left amount-label">40</label>
              </CCol>
            </CRow>
            <CRow class="d-flex d-sm-none">
              <CCol sm="12">
                <div class="text-center m-0">
                  <label style="vertical-align: top" class="price-label"
                    ><strong>RM</strong></label
                  >
                  <label class="amount-label">40</label>
                </div>
              </CCol>
            </CRow>
            <label class="text-center"><strong>Per Session</strong></label>
            <label class="text-center">
              Only one student for intensive 
              learning
            </label>
            <br />
            <hr />
            <label class="text-center"><strong>- For 18 years old onwards</strong></label>
            <label class="text-center">- Pay per Session/Monthly</label>
            <label class="text-center"
              >Any available subject (per subject)</label
            >
            <CRow class="p-2">
              <CCol sm="12" lg="12">
                <CButton
                  color="primary"
                  block
                  size="lg"
                  class="mt-3"
                  href="https://wa.me/600106597700?text=+Request info for package Adult 1 to 1 (1hr), 18 years old onwards"
                  >Select</CButton
                >
              </CCol>
            </CRow>
          </CCard>
        </CCol>
      </CRow>
      <h1 class="text-center mb-5 mt-5">Let's Compare Pickiddo & Others</h1>

      <CCard style="background: currentColor" class="d-none d-sm-flex">
        <CRow>
          <CCol sm="3" lg="3" class="border-right"></CCol>
          <CCol style="background: #f4f5ef" sm="3" lg="3" class="border-right">
            <div class="mt-2 text-center m-0">
              <img width="200" src="../assets/img/pickiddoTuition.png" /></div
          ></CCol>
          <CCol style="background: #f4f5ef" sm="3" lg="3" class="border-right">
            <div class="bg-custom-logo mt-2 text-center m-0">
              <img width="200" src="../assets/img/companyX.png" /></div
          ></CCol>
          <CCol style="background: #f4f5ef" sm="3" lg="3">
            <div class="bg-custom-logo mt-2 text-center m-0">
              <img width="200" src="../assets/img/physical.png" />
            </div>
          </CCol>
          <CCol sm="3" lg="3" class="border-right">
            <label class="float-left amount-label-title p-3"
              >Cost Per One Subject</label
            >
            <label class="float-left amount-label-title p-3"
              >No. Of Student Per Class</label
            >
            <label class="float-left amount-label-title p-3"
              >Own Supported Tools</label
            >
            <label class="float-left amount-label-title p-3">Payment</label>
            <label class="float-left amount-label-title p-3"
              >Class Conduct</label
            >
            <label class="float-left amount-label-title p-3"
              >Changeable Teacher</label
            >
            <label class="float-left amount-label-title p-3">App Name</label>
          </CCol>
          <CCol style="background: #ebedef" sm="3" lg="3" class="border-right">
            <label class="float-left amount-label-compare p-3">RM15/hr</label>
            <label class="float-left amount-label-compare p-3">
              1- 2 Student Only</label
            >
            <label class="float-left amount-label-compare p-3"> Web/Apps</label>
            <label class="float-left amount-label-compare p-3">
              Per Session
              <label style="font-size: 18px"> ( Top up Anytime ) </label></label
            >
            <label class="float-left amount-label-compare p-2">
              Live Video Conference</label
            >
            <label class="float-left amount-label-compare p-4">
              Up On Request</label
            >
            <label class="float-left amount-label-compare p-2"
              >Pickiddo ( iOS & Android )</label
            >
          </CCol>
          <CCol style="background: #ebedef" sm="3" lg="3" class="border-right">
            <label class="float-left amount-label-compare-sub p-3"
              >RM 90/mth</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              10 (or more)</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Web/Apps</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Per Month</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Live Video Conference</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Not Possible</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              X App ( Android Only )</label
            >
          </CCol>
          <CCol style="background: #ebedef" sm="3" lg="3">
            <label class="float-left amount-label-compare-sub pt-3 pb-2"
              >RM 230/mth
              <label style="font-size: 18px"> ( for 3 subjects) </label>
            </label>
            <label class="float-left amount-label-compare-sub p-3">
              20 (or more)
            </label>
            <label class="float-left amount-label-compare-sub p-3">
              Manual</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Per Month</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Physical Contact</label
            >
            <label class="float-left amount-label-compare-sub p-3">
              Not Possible</label
            >
            <label class="float-left amount-label-compare-sub p-3"> N/A</label>
          </CCol>
        </CRow>
      </CCard>

      <CCard class="d-flex d-sm-none">
        <CRow>
          <CCol style="background: #fff" sm="3" lg="3">
            <div style="background: #f4f5ef" class="text-center m-0">
              <img width="200" src="../assets/img/pickiddoTuition.png" />

              <br />
              <br />
              <label class="text-center p-2">Cost Per One Subject</label>
              <label class="text-center amount-label-compare-sm"
                >: RM15/hr</label
              >

              <br />
              <label class="text-center p-2">No. Of Student Per Class</label>

              <label class="text-center amount-label-compare-sm">
                : 1- 2 Student Only</label
              >
              <br />
              <label class="text-center p-2">Own Supported Tools</label>
              <label class="text-center amount-label-compare-sm">
                :Web/Apps</label
              >
              <br />
              <label class="text-center p-2">Payment</label>
              <label class="text-center amount-label-compare-sm">
                : Per Session ( Top up Anytime )
              </label>
                <br />
              <label class="text-center p-2">Class Conduct</label>
              <label class="text-center amount-label-compare-sm">
                : Live Video Conference
              </label>
              <br />
              <label class="text-center p-2"> Changeable Teacher</label>
              <label class="text-center amount-label-compare-sm">
                : Up On Request</label
              >
              <br />
              <label class="text-center p-2"> App Name</label>
              <label class="text-center amount-label-compare-sm"
                >: Pickiddo ( iOS & Android )</label
              >
            </div>
          </CCol>
          <CCol style="background: #fff" sm="3" lg="3" class="mt-2">
            <div style="background: #f4f5ef" class="text-center m-0">
              <img width="200" src="../assets/img/companyX.png" />
              <br />
              <br />
              <label class="text-center p-2">Cost Per One Subject</label>
              <label class="text-center amount-label-compare-sub-sm">
                RM 90/mth</label
              >
              <br />
              <label class="text-center p-2">No. Of Student Per Class</label>
              <label class="text-center amount-label-compare-sub-sm">
                10 (or more)</label
              >
              <br />
              <label class="text-center p-2">Own Supported Tools</label>
              <label class="text-center amount-label-compare-sub-sm">
                Web/Apps</label
              >
              <br />
              <label class="text-center p-2">Payment</label>
              <label class="text-center amount-label-compare-sub-sm">
                Per Month</label
              >
              <br />
              <label class="text-center p-2">Class Conduct</label>
              <label class="text-center amount-label-compare-sub-sm">
                Live Video Conference</label
              >
              <br />
              <label class="text-center p-2"> Changeable Teacher</label>
              <label class="text-center amount-label-compare-sub-sm">
                Not Possible</label
              >
              <br />
              <label class="text-center p-2"> App Name</label>
              <label class="text-center amount-label-compare-sub-sm">
                X App ( Android Only )</label
              >
            </div>
          </CCol>
          <CCol style="background: #fff" sm="3" lg="3" class="mt-2">
             <div style="background: #f4f5ef" class="text-center m-0">
                <img width="200" src="../assets/img/physical.png" />
                <br />
              <br />
               <label class="text-center p-2">Cost Per One Subject</label>
             <label class="text-center amount-label-compare-sub-sm">RM 230/mth
              <label style="font-size: 18px"> ( for 3 subjects) </label>
            </label>
             <br />
              <label class="text-center p-2">No. Of Student Per Class</label>
            <label class="text-center amount-label-compare-sub-sm">
              20 (or more)
            </label>
             <br />
              <label class="text-center p-2">Own Supported Tools</label>
             <label class="text-center amount-label-compare-sub-sm">
              Manual</label
            >
             <br />
              <label class="text-center p-2">Payment</label>
            <label class="text-center amount-label-compare-sub-sm">
              Per Month</label
            >
             <br />
              <label class="text-center p-2">Class Conduct</label>
             <label class="text-center amount-label-compare-sub-sm">
              Physical Contact</label
            >
             <br />
              <label class="text-center p-2"> Changeable Teacher</label>
            <label class="text-center amount-label-compare-sub-sm">
              Not Possible</label
            >
             <br />
              <label class="text-center p-2"> App Name</label>
            <label class="text-center amount-label-compare-sub-sm"> N/A</label>
            </div>
          </CCol>
        </CRow>
      </CCard>
      <br /><br />
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Login",
  components: {},
  data() {
    return {
      myStyle: {
        backgroundColor: "#fff",
      },
    };
  },
  async mounted() {},
  computed: {},
  methods: {},
};
</script>
